var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LaddaButton, { ZOOM_IN } from "react-ladda-button";
import { collateFormData } from "../../utils/helpers";
import React from "react";
import AutoHeightLoader from "../../components/AutoHeightLoader";
import BlockUi from "react-block-ui";
import CartContents from "./Contents";
import CoolerModal from "./CoolerModal";
import Flatpickr from "react-flatpickr";
import ReactDOM from "react-dom/client";
import { SlideDown } from "react-slidedown";
import Swal from "sweetalert2";
import ZipCheckResults from "../../components/ZipCheckResults";
import debounce from "debounce";
class Cart extends React.Component {
    constructor(props) {
        super(props);
        // ─── Contents Of Cooler Bag Notification ─────────────────────────────
        this.coolerContent = () => {
            const { showCoolerModal, itemQuantity, coolerBag, isSubmitting } = this.state;
            const openModal = () => {
                this.setState({
                    showCoolerModal: true,
                });
            };
            const closeModal = () => {
                this.setState({
                    showCoolerModal: false,
                });
            };
            const handleSubmit = () => {
                this.setState({
                    isSubmitting: true,
                });
                const form = document.createElement("form");
                form.method = "POST";
                form.action = "/cart";
                const hiddenField1 = document.createElement("input");
                hiddenField1.type = "hidden";
                hiddenField1.name = "action";
                hiddenField1.value = "add";
                form.appendChild(hiddenField1);
                const hiddenField2 = document.createElement("input");
                hiddenField2.type = "hidden";
                hiddenField2.name = "id";
                hiddenField2.value = (coolerBag === null || coolerBag === void 0 ? void 0 : coolerBag.id.toString()) || "";
                form.appendChild(hiddenField2);
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            };
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "alert alert-solid-info mx-3 cooler-alert" },
                    React.createElement("i", { className: "far fa-snowflake" }),
                    React.createElement("p", null,
                        "Not going to be in? We can leave your order in a cooler bag.\u00A0",
                        React.createElement("a", { href: "#", className: "bag-modal-link", onClick: openModal }, "Find\u00A0out\u00A0more")),
                    React.createElement("p", { className: "price" }, "$3.00 each"),
                    React.createElement(LaddaButton, { type: "submit", className: "btn btn-cta", "data-style": ZOOM_IN, loading: isSubmitting, onClick: handleSubmit },
                        React.createElement("span", { className: "far fa-plus fa-sm" }),
                        " Add to cart")),
                itemQuantity > 0 && (React.createElement(CoolerModal, { itemQuantity: itemQuantity, coolerBag: coolerBag, show: showCoolerModal, onExit: closeModal }))));
        };
        // ─── Callback For Changing Cart Items ────────────────────────────────
        this.changeItem = (id, qty) => {
            if (qty < 1)
                return;
            const items = this.state.items;
            const newItems = items.map((item) => {
                if (item.id == id) {
                    item.qty = qty;
                    return item;
                }
                return item;
            });
            this.setState({
                items: newItems,
            });
            this.saveAndReloadCartDebounce();
        };
        //Saves the "Update cart" details and reloads the data
        this.saveAndReloadCart = () => __awaiter(this, void 0, void 0, function* () {
            this.setState({ blocking: true });
            //Quickly save the state
            yield this.saveCheckoutState();
            //Grab form data
            const form = document.getElementById("cart-contents");
            const data = collateFormData(form);
            const response = yield fetch("/cart", {
                method: "POST",
                cache: "no-cache",
                body: data,
            });
            if (response.status == 200) {
                yield this.loadData();
                this.setState({ blocking: false });
            }
            else {
                //TODO: Error
            }
        });
        this.saveAndReloadCartDebounce = debounce(this.saveAndReloadCart, 300);
        // ─── Callback For Deleting Cart Items ────────────────────────────────
        this.deleteItem = (id) => {
            Swal.fire({
                icon: "warning",
                title: "Remove this item?",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: true,
                confirmButtonColor: "#d33",
                confirmButtonText: "Remove from cart",
                preConfirm: (value) => __awaiter(this, void 0, void 0, function* () {
                    Swal.showLoading();
                    yield fetch("/cart", {
                        method: "POST",
                        body: new URLSearchParams(`action=remove&id=${id}`),
                    });
                    const newItems = this.state.items.filter((item) => item.id !== id);
                    if (newItems.length == 0)
                        window.location.reload();
                    this.setState({
                        items: newItems,
                    });
                    return true;
                }),
            });
        };
        // ─── Misc Cart Date And Pricing Functions ────────────────────────────
        this.getMinDate = () => this.state.data.delivery_days[0].delivery_date;
        this.getMaxDate = () => this.state.data.delivery_days[this.state.data.delivery_days.length - 1]
            .delivery_date;
        this.getSubTotal = () => this.state.items.reduce((val, item) => (val += item.price * item.qty), 0);
        this.getShipping = () => (this.state.deliveryType == "1" ? 5 : 0);
        this.meetsMinDeliveryAmount = () => this.getSubTotal() >= (this.state.minDeliveryValue || 0);
        this.getTax = () => this.state.items.reduce((val, item) => {
            if (!item.taxable || !this.state.taxRate)
                return val;
            const taxPer = (item.price / 100) * this.state.taxRate;
            return (val += taxPer * item.qty);
        }, 0);
        this.getTotal = () => this.getSubTotal() -
            (this.state.discount || 0) +
            (this.getTax() || 0) +
            this.getShipping();
        // ─── Callback For Submitting Coolbar Modal ───────────────────────────
        this.submitForm = (e) => {
            this.setState({
                isSubmitting: true,
            });
            e.currentTarget.closest("form").submit();
        };
        // ─── Callback Changing From Single To Subscription And Vice Versa ────
        this.onPurchaseChange = (event) => {
            this.setState({
                purchaseType: event.target.value,
            });
        };
        // ─── Callback For Changing Delivery Type ─────────────────────────────
        this.onDeliveryChange = (event) => {
            //When we change delivery type, we need to reset some variables
            this.setState({
                deliveryType: event.target.value,
                showZipMessage: false,
                zipResult: false,
                zipCheck: "",
                location: "",
            });
        };
        // ─── Callback For Changing Location ──────────────────────────────────
        this.onLocationChange = (event) => {
            this.setState({
                location: event.target.value,
            });
        };
        // ─── Zip Checking Functions ──────────────────────────────────────────
        this.zipCheckChange = (event) => {
            this.setState({
                zipCheck: event.target.value,
            });
        };
        this.zipCheckKeyDown = (event) => {
            if (event.key == "Enter") {
                event.preventDefault();
                this.performZipCheck();
            }
        };
        this.performZipCheck = () => __awaiter(this, void 0, void 0, function* () {
            const { zipCheck } = this.state;
            //Minimum time (in ms) that loader should be displayed for
            const MINTIME = 1000;
            this.setState({
                checkingZip: true,
            });
            const startTime = Date.now();
            const response = yield fetch(`/ajax/checkDeliveryPostcode?pcode=${zipCheck}`);
            const data = (yield response.json());
            const endTime = Date.now();
            const timeTaken = endTime - startTime;
            const ms = Math.max(0, Math.min(MINTIME, MINTIME - timeTaken));
            setTimeout(() => {
                var _a;
                this.setState({
                    checkingZip: false,
                    zipResult: data.can_deliver,
                    showZipMessage: true,
                    location: ((_a = data.franchise_id) === null || _a === void 0 ? void 0 : _a.toString()) || "",
                });
            }, ms);
        });
        this.setDate = (value) => {
            this.setState({
                date: value.toString(),
            });
        };
        this.state = {
            isLoading: true,
            data: null,
            items: [],
            zipCheck: "",
            location: "",
            coolerBag: null,
            coupon: "",
            showCoolerModal: false,
            itemQuantity: 0,
            checkingZip: false,
            showZipMessage: false,
            zipResult: false,
            isSubmitting: false,
            blocking: false,
        };
        this.loadData();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state && prevState.items == this.state.items) {
            this.saveCheckoutState();
        }
    }
    render() {
        const { purchaseType, deliveryType, zipCheck, location, data, checkingZip, showZipMessage, zipResult, minDeliveryValue, coolerBag, date, isSubmitting, } = this.state;
        //Do we allow the user to continue
        const allowContinue = 
        //Local delivery
        //has passed ZIP check, and has valid location and date, and meats min order value
        (deliveryType == "1" &&
            zipResult == true &&
            location != "" &&
            date != "" &&
            this.meetsMinDeliveryAmount()) ||
            //Pickup
            //has valid location and date
            (deliveryType == "2" && location != "" && date != "");
        return (React.createElement(BlockUi, { tag: "div", blocking: this.state.blocking, loader: React.createElement("div", { className: "spinner-border" }), keepInView: true },
            React.createElement(AutoHeightLoader, { isLoading: data == null },
                React.createElement("div", { className: "row" },
                    React.createElement(CartContents, { subTotal: this.getSubTotal(), discount: this.state.discount || 0, shipping: this.getShipping(), tax: this.getTax(), total: this.getTotal(), items: this.state.items, coupon: this.state.coupon, onChange: this.changeItem, onDelete: this.deleteItem, coolerContent: this.coolerContent(), coolerBag: coolerBag }),
                    React.createElement("div", { className: "col-lg" },
                        React.createElement("div", { className: "card custom-card card-body" },
                            React.createElement("form", { method: "post", id: "cart-actions" }, data !== null && (React.createElement("div", null,
                                React.createElement("h2", { className: "h4" }, "Order Type"),
                                React.createElement("p", null, "Why not get your meals delivered every week? Select 'Weekly subscription' to find out more"),
                                React.createElement("div", { className: "row cart-order-type" },
                                    React.createElement("div", { className: "col-sm col-lg-12 col-xl mb-3 mb-sm-0 mb-lg-3 mb-xl-0" },
                                        React.createElement("div", { className: "form-check custom-check" },
                                            React.createElement("input", { className: "form-check-input", type: "radio", id: "purchaseType1", name: "purchaseType", value: "1", checked: purchaseType == "1", onChange: this.onPurchaseChange }),
                                            React.createElement("label", { className: "form-check-label", htmlFor: "purchaseType1" },
                                                React.createElement("span", { className: "custom-check-text" }, "Single order")))),
                                    React.createElement("div", { className: "col-sm col-lg-12 col-xl" },
                                        React.createElement("div", { className: "form-check custom-check arrow-check" },
                                            React.createElement("input", { className: "form-check-input", type: "radio", id: "purchaseType2", name: "purchaseType", value: "2", checked: purchaseType == "2", onChange: this.onPurchaseChange }),
                                            React.createElement("label", { className: "form-check-label", htmlFor: "purchaseType2" },
                                                React.createElement("span", { className: "custom-check-text" }, "Weekly subscription"))))),
                                React.createElement(SlideDown, { closed: purchaseType != "2" },
                                    React.createElement("div", { className: "cart-info-list" },
                                        React.createElement("ul", null,
                                            React.createElement("li", null, "Choose your delivery day"),
                                            React.createElement("li", null, "Update your meal plan weekly"),
                                            React.createElement("li", null, "Cancel online at any time")))),
                                React.createElement("h2", { className: "h4" }, "Choose delivery type"),
                                deliveryType && (React.createElement(SlideDown, { closed: (deliveryType == "1" &&
                                        this.meetsMinDeliveryAmount()) ||
                                        deliveryType == "2" },
                                    React.createElement("div", { className: "alert alert-solid-warning" },
                                        "Delivery is not available for orders under $",
                                        this.state.minDeliveryValue,
                                        React.createElement("br", null),
                                        "You can still pickup your order fresh from our store."))),
                                React.createElement("div", { className: "row flex-nowrap mt-3" },
                                    React.createElement("div", { className: "col" },
                                        React.createElement("div", { className: "form-check custom-check arrow-check" },
                                            React.createElement("input", { className: "form-check-input", type: "radio", id: "deliveryType1", name: "deliveryType", value: "1", checked: deliveryType == "1", onChange: this.onDeliveryChange }),
                                            React.createElement("label", { className: "form-check-label", htmlFor: "deliveryType1" },
                                                React.createElement("span", { className: "custom-check-text" }, "Local delivery")))),
                                    React.createElement("div", { className: "col" },
                                        React.createElement("div", { className: "form-check custom-check arrow-check" },
                                            React.createElement("input", { className: "form-check-input", type: "radio", id: "deliveryType2", name: "deliveryType", value: "2", checked: deliveryType == "2", onChange: this.onDeliveryChange }),
                                            React.createElement("label", { className: "form-check-label", htmlFor: "deliveryType2" },
                                                React.createElement("span", { className: "custom-check-text" }, "Store pickup"))))),
                                React.createElement("div", { className: "holder-light" },
                                    React.createElement(SlideDown, { closed: deliveryType != "1" },
                                        React.createElement("p", { className: "mb-1" }, "Please enter your zip to continue"),
                                        React.createElement("div", { className: "input-group mb-3" },
                                            React.createElement("input", { type: "text", className: "form-control", placeholder: "Enter your ZIP code", name: "zipCheck", value: zipCheck, id: "zipCheck", onChange: this.zipCheckChange, onKeyDown: this.zipCheckKeyDown }),
                                            React.createElement("button", { className: "btn btn-light", type: "button", id: "zipCheck-btn", onClick: this.performZipCheck }, "Check"))),
                                    React.createElement(ZipCheckResults, { checkingZip: checkingZip, showZipMessage: showZipMessage, zipResult: zipResult }),
                                    React.createElement(SlideDown, { id: "storeSelect", closed: deliveryType != "2" },
                                        React.createElement("h3", { className: "h5" }, "Please select a store to pick up from"),
                                        React.createElement("ul", { className: "store-grid" }, data.stores.map((store, idx) => (React.createElement("li", { key: idx },
                                            React.createElement("div", { className: "form-check custom-check" },
                                                React.createElement("input", { type: "radio", className: "form-check-input", name: "location", id: store.id.toString(), value: store.id, checked: location == store.id.toString(), onChange: this.onLocationChange }),
                                                React.createElement("label", { className: "form-check-label", htmlFor: store.id.toString() },
                                                    React.createElement("span", { className: "custom-check-text" },
                                                        store.name,
                                                        React.createElement("br", null),
                                                        React.createElement("span", { className: "text-muted" },
                                                            store.address1,
                                                            ", ",
                                                            store.postcode,
                                                            React.createElement("br", null),
                                                            "Tel: ",
                                                            store.telephone))))))))),
                                    React.createElement("p", { className: "mb-1 mt-4" },
                                        "Your ",
                                        deliveryType == "1" ? "delivery" : "pickup",
                                        " date"),
                                    React.createElement(Flatpickr, { value: date, name: "date", options: {
                                            minDate: this.getMinDate(),
                                            maxDate: this.getMaxDate(),
                                            enable: data.delivery_days.map((d) => d.delivery_date),
                                            dateFormat: "Y-m-d",
                                            altInput: true,
                                            altFormat: "m/d/Y",
                                            onChange: (dates, dateStr) => this.setState({
                                                date: dateStr,
                                            }),
                                        } }),
                                    React.createElement("br", null),
                                    React.createElement("div", { className: "text-end" },
                                        React.createElement("input", { type: "hidden", name: "processCheckout", value: "true" }),
                                        React.createElement(LaddaButton, { type: "submit", className: "btn btn-cta btn-lg", "data-style": ZOOM_IN, loading: isSubmitting, onClick: (e) => this.submitForm(e), disabled: !allowContinue },
                                            "Checkout ",
                                            React.createElement("i", { className: "far fa-chevron-right" }))))))),
                            React.createElement("div", { id: "cart-modal-container" })))))));
    }
    // ─── Load All Data ───────────────────────────────────────────────────
    loadData() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/ajax/getCartOptions");
            const data = (yield response.json());
            this.setState({
                data: data,
                //date: data.delivery_days[0].delivery_date,
                zipCheck: ((_a = data.address) === null || _a === void 0 ? void 0 : _a.zip) || "",
                zipResult: ((_b = data.address) === null || _b === void 0 ? void 0 : _b.canDeliver) || false,
                location: ((_d = (_c = data.address) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.toString()) || "",
                coolerBag: data.cooler_bag,
            });
            const cartResponse = yield fetch("/ajax/cartData");
            const cartData = (yield cartResponse.json());
            //Determine if the date from cartData is valid
            let deliveryDate = data.delivery_days[0].delivery_date;
            if (cartData.date != null) {
                //If not null, and date is valid, use it.
                const isValid = data.delivery_days.find((d) => d.delivery_date == cartData.date) !==
                    undefined;
                if (isValid)
                    deliveryDate = cartData.date;
            }
            this.setState({
                cartId: cartData.cartId,
                date: deliveryDate,
                deliveryType: cartData.deliveryType,
                purchaseType: cartData.purchaseType,
                location: cartData.location,
                items: cartData.items,
                itemQuantity: cartData.itemQuantity,
                quantity: cartData.quantity,
                shipping: cartData.shipping,
                discount: cartData.discount,
                status: cartData.status,
                subTotal: cartData.subTotal,
                total: cartData.total,
                taxRate: cartData.taxRate,
                minDeliveryValue: cartData.minDeliveryValue,
                coupon: cartData.coupon,
            });
            setTimeout(() => {
                this.setState({
                    isLoading: false,
                });
            }, 0);
        });
    }
    // ─── Save Cart State To Db ───────────────────────────────────────────
    saveCheckoutState() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.isLoading)
                return;
            const saveState = {
                cartId: this.state.cartId,
                purchaseType: this.state.purchaseType,
                deliveryType: this.state.deliveryType,
                zipCheck: this.state.zipCheck,
                location: this.state.location,
                date: this.state.date,
            };
            //console.log(saveState)
            yield fetch("/ajax/cartData", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Accept: "*/*",
                },
                body: new URLSearchParams(saveState),
            });
        });
    }
}
// ─── Initialisation ─────────────────────────────────────────────────────────────
const cartForm = document.getElementById("cart-actions");
if (cartForm) {
    const cartRoot = ReactDOM.createRoot(cartForm);
    cartRoot.render(React.createElement(Cart, null));
}
// ─── Interfaces ─────────────────────────────────────────────────────────────────
